import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getCampaign = ({ churchId, campaignId }) => {
  return axios.get(`/churches/${churchId}/campaigns/${campaignId}`);
};

export const useCampaign = ({ churchId, campaignId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["campaign", churchId, campaignId],
    queryFn: () => getCampaign({ churchId, campaignId }),
    select: data => data.result
  });
};
